var exports = {
  "X7": "UserProfileBadges.module__containerModal___Z2RHTU",
  "j4": "UserProfileBadges.module__containerModalMobile___Z2RHTU",
  "pP": "UserProfileBadges.module__containerModalDesktop___Z2RHTU",
  "RS": "UserProfileBadges.module__containerPopout___Z2RHTU",
  "Qk": "UserProfileBadges.module__badgeMobile___Z2RHTU",
  "EJ": "UserProfileBadges.module__badgeDesktop___Z2RHTU",
  "X8": "UserProfileBadges.module__sequenceBadge___Z2RHTU",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___Z2RHTU",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___Z2RHTU",
  "nf": "UserProfileBadges.module__link___Z2RHTU",
};

module.exports = exports;
